import moment from "moment";

export default date => {
  return moment(new Date(date)).fromNow();
};
